import React, { useEffect, useState } from 'react';
import { adminApi } from '../../api/client';
import Modal from '../../components/common/Modal';
import Spinner from '../../components/common/Spinner';
import { FaPlus, FaTrash, FaDownload, FaBookOpen } from 'react-icons/fa';
import toast from 'react-hot-toast';

export default function Library() {
  const [books,      setBooks]      = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading,    setLoading]    = useState(true);
  const [modal,      setModal]      = useState(false);
  const [catModal,   setCatModal]   = useState(false);
  const [catName,    setCatName]    = useState('');
  const [catFilter,  setCatFilter]  = useState('');
  const [form,       setForm]       = useState({ title:'', author:'', isbn:'', category_id:'' });
  const [file,       setFile]       = useState(null);

  const load = () => {
    Promise.all([adminApi.getBooks(), adminApi.getCategories()])
      .then(([b, c]) => { setBooks(b.data.data); setCategories(c.data.data); })
      .finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    if (!file) return toast.error('Please select a PDF file');
    const fd = new FormData();
    Object.entries(form).forEach(([k,v]) => fd.append(k, v));
    fd.append('file', file);
    const token = localStorage.getItem('access_token');
    if (token) fd.append('_token', token);
    try { await adminApi.addBook(fd); toast.success('Book added'); setModal(false); setFile(null); load(); }
    catch (err) { toast.error(err.response?.data?.message || 'Failed'); }
  };

  const handleAddCat = async (e) => {
    e.preventDefault();
    try { await adminApi.addCategory({ name: catName }); toast.success('Category added'); setCatModal(false); setCatName(''); load(); }
    catch { toast.error('Failed'); }
  };

  const filtered = catFilter ? books.filter(b => String(b.category_id) === catFilter) : books;

  return (
    <div>
      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div><h2>Library</h2><p>Digital book collection</p></div>
        <div style={{ display: 'flex', gap: 10 }}>
          <button className="sms-btn sms-btn-outline" onClick={() => setCatModal(true)}><FaPlus size={12} /> Category</button>
          <button className="sms-btn sms-btn-primary" onClick={() => { setForm({ title:'',author:'',isbn:'',category_id:'' }); setFile(null); setModal(true); }}><FaPlus size={12} /> Add Book</button>
        </div>
      </div>

      <div style={{ marginBottom: 16 }}>
        <select className="sms-input" style={{ width: 220 }} value={catFilter} onChange={e => setCatFilter(e.target.value)}>
          <option value="">All Categories</option>
          {categories.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
      </div>

      {loading ? <Spinner /> : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(240px,1fr))', gap: 16 }}>
          {filtered.map(b => (
            <div key={b.book_id} className="sms-card-sm" style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <div style={{ width: '100%', height: 120, background: '#f0f2f5', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                {b.cover_url ? <img src={b.cover_url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <FaBookOpen size={36} color="#d1d5db" />}
              </div>
              <div style={{ fontWeight: 600, fontSize: '0.92rem' }}>{b.title}</div>
              {b.author && <div style={{ color: '#6b7280', fontSize: '0.82rem' }}>by {b.author}</div>}
              <div style={{ fontSize: '0.78rem', color: '#9ca3af' }}>{b.category_name || 'Uncategorised'}</div>
              <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
                {b.file_url && <a href={b.file_url} target="_blank" rel="noreferrer" className="sms-btn sms-btn-outline sms-btn-sm" style={{ flex: 1, justifyContent: 'center' }}><FaDownload size={12} /> Download</a>}
                <button className="sms-btn sms-btn-danger sms-btn-sm" onClick={async () => { if (window.confirm('Delete?')) { await adminApi.deleteBook(b.book_id); toast.success('Deleted'); load(); } }}><FaTrash size={12} /></button>
              </div>
            </div>
          ))}
          {filtered.length === 0 && <div style={{ gridColumn:'1/-1', textAlign:'center', color:'#9ca3af', padding:'60px 0' }}>No books found</div>}
        </div>
      )}

      <Modal show={modal} onClose={() => setModal(false)} title="Add Book">
        <form onSubmit={handleSave}>
          {[['Title','title',true],['Author','author'],['ISBN','isbn']].map(([l,k,r]) => (
            <div key={k} style={{ marginBottom: 14 }}>
              <label className="sms-label">{l}{r && <span style={{ color:'#ef4444' }}>*</span>}</label>
              <input className="sms-input" value={form[k]} onChange={e => setForm({ ...form, [k]: e.target.value })} required={!!r} />
            </div>
          ))}
          <div style={{ marginBottom: 14 }}>
            <label className="sms-label">Category</label>
            <select className="sms-input" value={form.category_id} onChange={e => setForm({ ...form, category_id: e.target.value })}>
              <option value="">No category</option>
              {categories.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </div>
          <div style={{ marginBottom: 20 }}>
            <label className="sms-label">PDF File <span style={{ color:'#ef4444' }}>*</span></label>
            <input className="sms-input" type="file" accept=".pdf" onChange={e => setFile(e.target.files[0])} required />
          </div>
          <div style={{ display: 'flex', gap: 10 }}>
            <button type="submit" className="sms-btn sms-btn-primary">Upload Book</button>
            <button type="button" className="sms-btn sms-btn-outline" onClick={() => setModal(false)}>Cancel</button>
          </div>
        </form>
      </Modal>

      <Modal show={catModal} onClose={() => setCatModal(false)} title="Add Category" size="sm">
        <form onSubmit={handleAddCat}>
          <div style={{ marginBottom: 16 }}>
            <label className="sms-label">Category Name</label>
            <input className="sms-input" value={catName} onChange={e => setCatName(e.target.value)} required placeholder="e.g. Science Fiction" />
          </div>
          <div style={{ display: 'flex', gap: 10 }}>
            <button type="submit" className="sms-btn sms-btn-primary">Add</button>
            <button type="button" className="sms-btn sms-btn-outline" onClick={() => setCatModal(false)}>Cancel</button>
          </div>
        </form>
      </Modal>
    </div>
  );
}
